<div class="modal-content">
    <div class="modal-body modal-padding">
        <h5 [innerHTML]="bookmark_rename | sanitizeHtml"></h5>
        <input id="rename-view-title" [(ngModel)]="value" class="panel-text-box" maxlength="100" placeholder="Enter label here" type="text">
        <div class="button-wrapper">
            <button class="modal-button-style" id="rename_button" data-dismiss="modal" viewid="721" viewindex="0" (click)="save()">Save</button>
            <button class="modal-button-style" data-dismiss="modal" (click)="close()">Cancel</button>
        </div>
    </div>
</div>
